import { render, staticRenderFns } from "./Municipalities.vue?vue&type=template&id=eaaeb4da&scoped=true&"
import script from "./Municipalities.vue?vue&type=script&lang=js&"
export * from "./Municipalities.vue?vue&type=script&lang=js&"
import style0 from "./Municipalities.vue?vue&type=style&index=0&id=eaaeb4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaeb4da",
  null
  
)

export default component.exports